import React from 'react';
import AuthTransitionSplash from '@wms/auth-transition/AuthTransitionSplash';
import logoEmpresaFallback from '../assets/logo_empresa.png';

export {
  clearAuthTransition as clearLoginTransitionProgress,
  isAuthTransitionVisible as isLoginTransitionActive,
  startLoginTransitionProgress,
} from '../utils/authTransition';

/**
 * Splash de transición LoginPortal (login → tenant / continuidad post-logout).
 */
export default function LoginTransitionLoader({
  ariaLabel = 'Cargando',
  logoSrc = logoEmpresaFallback,
  logoAlt = 'Logo',
  fadeOut = false,
}) {
  return (
    <AuthTransitionSplash
      logoSrc={logoSrc || logoEmpresaFallback}
      logoAlt={logoAlt}
      ariaLabel={ariaLabel}
      fadeOut={fadeOut}
    />
  );
}
